import { PrismicNextImage, PrismicNextLink } from "@prismicio/next";
import { PrismicRichText } from "@prismicio/react";
import React from "react";
import { IoArrowForwardOutline } from "react-icons/io5";

const bodyComponent = {
  heading4: ({ children }) => (
    <h4 className="text-base text-[#272B2E]">{children}</h4>
  ),
  heading5: ({ children }) => (
    <h5 className="text-base text-[#272B2E]">{children}</h5>
  ),
  heading6: ({ children }) => (
    <h6 className="text-base text-[#272B2E]">{children}</h6>
  ),
  paragraph: ({ children }) => (
    <p className="text-base text-[#272B2E] line-clamp-4">{children}</p>
  ),
  strong: ({ children }) => (
    <strong className="font-semibold">{children}</strong>
  ),
};

const PracticeAreaGrid = ({ data }) => {
  return (
    <PrismicNextLink href={`practice-areas/${data?.uid}`}>
      <PrismicNextImage
        field={data?.data?.featured_image}
        fallbackAlt=""
        className="w-full min-h-[203px] max-h-[203px] sm:max-h-[300px] md:max-h-[203px] object-cover"
      />
      <div className="mt-[16px] mb-[8px]">
        <h3 className="title-font title-small text-[#1F2223]">
          {data?.data?.practice_title}
        </h3>
      </div>
      <div className="mt-1 md:mt-[10px] pb-[6px]">
        <PrismicRichText
          field={data?.data?.excerpt}
          components={bodyComponent}
        />
      </div>
      <div className="flex items-center gap-1 text-[#B78562] text-base font-bold my-[10px]">
        <span>Read more</span>
        <IoArrowForwardOutline size={20} color="#B78562" />
      </div>
    </PrismicNextLink>
  );
};

export default PracticeAreaGrid;
